export default __webpack_public_path__ + "pdf/Inspection-Report-VW-Canada.pdf";